export default {"src":"/_next/static/media/help_red.6a14e1ea.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};